export const FACE_IMAGES: Partial<Record<number, string>> = {
  0: 'FACE_0_r9q1el',
  1: 'FACE_25_ezcf3e',
  2: 'FACE_50_fhghao',
  3: 'FACE_75_ncvzkf',
  4: 'FACE_100_e7rflj',
}
